module.exports = __webpack_public_path__ + "img/logo-up-new-1.9b9f4147.png";